var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 645"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.50001 5C6.77615 5 7 5.25583 7 5.57142V8.42858C7 8.74416 6.77615 9 6.50001 9C6.22386 9 6 8.74416 6 8.42858V5.57142C6 5.25583 6.22386 5 6.50001 5Z",
    fill: "#0081DF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.50001 3C6.77615 3 7 3.22385 7 3.49999C7 3.77614 6.77615 4 6.50001 4C6.22386 4 6 3.77614 6 3.49999C6 3.22385 6.22386 3 6.50001 3Z",
    fill: "#0081DF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.5C0 2.91014 2.91015 0 6.50001 0C10.0898 0 13 2.91014 13 6.5C13 10.0899 10.0898 13 6.50001 13C2.91015 13 0 10.0899 0 6.5ZM6.50001 1.30001C3.62812 1.30001 1.29999 3.62812 1.29999 6.5C1.29999 9.37188 3.62812 11.7 6.50001 11.7C9.37189 11.7 11.7 9.37188 11.7 6.5C11.7 3.62812 9.37189 1.30001 6.50001 1.30001Z",
    fill: "#0081DF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.a47bbbd6110ab2f0458b8a2ef8656838.svg";
export { ForwardRef as ReactComponent };